import { setAuthToken } from '@/lib/auth/auth-token';
import type { RequestResponse } from '@/types';

/** Session tokens only — Google `setupToken` is sent in complete-signup body, not stored as Bearer. */
const TOKEN_FIELDS = ['token', 'accessToken', 'access_token'] as const;

export const extractAuthToken = (payload: unknown): string | null => {
  if (!payload || typeof payload !== 'object') return null;

  const record = payload as Record<string, unknown>;

  for (const field of TOKEN_FIELDS) {
    const value = record[field];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return null;
};

/** Saves an auth token when present on an API response payload. */
export const persistAuthTokenFromResponse = (
  response: RequestResponse<unknown> & { token?: string }
): void => {
  const token =
    extractAuthToken(response.data) ??
    (typeof response.token === 'string' && response.token.trim()
      ? response.token.trim()
      : null);

  if (token) {
    setAuthToken(token);
  }
};
